import { Box, Flex } from 'rebass';

import Photo from 'components/photo';

const THUMBNAIL_WIDTH = 327;

export default function Gallery({ gallery }) {
  return (
    <Flex flexDirection={['column', 'row']}>
      {Array(3)
        .fill()
        .map((_, column) => (
          <Box key={column} width={[1, 1 / 3]} marginRight={1}>
            {gallery.photos
              .filter((_, index) => index % 3 === column)
              .map((photo) => {
                return (
                  <Box sx={{ marginBottom: 1 }} key={photo.id}>
                    <Photo
                      item={photo}
                      width={THUMBNAIL_WIDTH}
                      href={`/${gallery.id}/${photo.id}`}
                      selectable={gallery?.actions?.length > 0}
                      gallery={gallery}
                      shallow={true}
                      scroll={false}
                      sizes={`(max-width: 40em) 100vw, ${THUMBNAIL_WIDTH}px`}
                    />
                  </Box>
                );
              })}
          </Box>
        ))}
    </Flex>
  );
}
